import React, { useEffect, useMemo, useState } from "react";
import { useForm } from "react-hook-form";
import { getFormBaseValidationRule } from "../../utils/form/form-utils";
import EzControlledInputWithFloatingLabel from "../../common/EzForm/EzControlledInput/WithFloatingLabel";
import { Box, Button, Typography } from "@mui/material";
import styleCss from "./style.module.css";
import { postApiLoginAsyn } from "../../services/PostAPI.js";
import { Navigate } from "react-router-dom";
import EzControlledPasswordWithFloatingLabel from "../../common/EzForm/EZControlledPassword/WithFloatingLabel";
import { useStyles } from "./style";
import { API_URL } from "../../utils/constant.js";
import Forgot from "./Forgot.js";
import { getMenuAccess } from "./login-utils.js";
import ParticleBackground from "./ParticleBackground.js";

export default function Login(props) {
  const classes = useStyles();
  const formFieldValueMap = {
    email: "",
    password: "",
  };
  const {
    control,
    formState: { errors, isDirty },
    watch,
    handleSubmit,
    reset,
  } = useForm({
    defaultValues: useMemo(() => {
      return formFieldValueMap;
    }, [formFieldValueMap]),
  });
  const [errorMessage, setErrorMessage] = useState("");
  const [error, setError] = useState(false);
  const [isForot, setIsForot] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const getFormErrorMessage = (name) => {
    return (
      errors[name] && <small className="p-error">{errors[name].message}</small>
    );
  };

  const userPassword = (name, label) => {
    return (
      <EzControlledPasswordWithFloatingLabel
        name={name}
        control={control}
        label={label}
        rules={getFormBaseValidationRule().DEFAULT.VALIDATION_RULE}
        isError={errors[name]}
        errorMsg={getFormErrorMessage(name)}
      />
    );
  };
  const genericInput = (name, label) => {
    return (
      <EzControlledInputWithFloatingLabel
        name={name}
        control={control}
        label={label}
        rules={getFormBaseValidationRule().DEFAULT.VALIDATION_RULE}
        isError={errors[name]}
        errorMsg={getFormErrorMessage(name)}
      />
    );
  };
  const routForgot = () => {
    setIsForot(!isForot);
  };
  const onSubmit = async (data) => {
    setIsLoading(true);
    setError(false);
    let sendData = {
      email: data.email,
      password: data.password,
    };
    try {
      let res = await postApiLoginAsyn(API_URL.login, sendData);
      if (res.token != null) {
        await getMenuAccess(res.token, res.userId);
        localStorage.setItem("username", res.userName);
        localStorage.setItem("token", res.token);
        localStorage.setItem("userId", res.userId);
        props.callBack();
      } else {
        setError(true);
        setErrorMessage("Invalid credentials");
        localStorage.removeItem("token");
        localStorage.removeItem("username");
      }
    } catch (err) {
      setError(true);
      setErrorMessage("Something went wrong");
    } finally {
      setIsLoading(false);
    }
  };
  if (
    localStorage.getItem("token") !== "" &&
    localStorage.getItem("token") != null &&
    localStorage.getItem("token") !== undefined
  ) {
    return <Navigate to="/dashboard" />;
  }
  return (
    <div id="loginwrap" className={styleCss.loginwrapper}>
      <ParticleBackground />
      {!isForot ? (
        <form onSubmit={handleSubmit(onSubmit)} className="p-fluid">
          <Box className={styleCss.loginbox}>
            {/* Logo */}
            <Box className={styleCss.logoadmin}>
              <img src="/RezRevolution-logo.png" alt="Rez Revolution" />
            </Box>

            {/* Welcome Text */}
            <Box className={styleCss.logotext}>Welcome Back</Box>
            <Box className={styleCss.subtitle}>
              Sign in to continue to your dashboard
            </Box>

            {/* Error Message */}
            {error && (
              <Box className={styleCss.errorMessage}>
                {errorMessage}. Please try again.
              </Box>
            )}

            {/* Email Field */}
            <Box className={styleCss.formField}>
              <label className={styleCss.user_icon}>
                <span className="pi pi-user"></span>
              </label>
              {genericInput("email", "Email or Username")}
            </Box>

            {/* Password Field */}
            <Box className={styleCss.formField}>
              <label className={styleCss.user_icon}>
                <span className="pi pi-lock"></span>
              </label>
              {userPassword("password", "Password")}
            </Box>

            {/* Buttons */}
            <Box className={classes.buttonpan}>
              <Button
                variant="contained"
                color="secondary"
                className={classes.loginbutton}
                type="submit"
                disabled={isLoading}
              >
                {isLoading ? (
                  <span
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                    }}
                  >
                    <i
                      className="pi pi-spin pi-spinner"
                      style={{ fontSize: "18px" }}
                    ></i>
                    Signing in...
                  </span>
                ) : (
                  "Sign In"
                )}
              </Button>

              <Button
                onClick={routForgot}
                className={classes.forgot}
                type="button"
              >
                Forgot your password?
              </Button>
            </Box>

            {/* Footer */}
            {/* <Box className={styleCss.footerText}>
              Powered by{" "}
              <a
                href="https://zoomrentals.com/"
                target="_blank"
                rel="noopener noreferrer"
              >
                Zoom Rentals
              </a>
            </Box> */}
          </Box>
        </form>
      ) : (
        <Forgot backtologin={routForgot} />
      )}
    </div>
  );
}
